<!-- HM stepper -->
<template>
  <div :id="id">
    <ol class="step-indicator">
      <li v-for="(step, index) in steps" :key="id + index" :class="{ active: current == step.id, complete: current > step.id }">
        <div class="step">
          <i :class="current > step.id ? step.iconComplete : step.icon"></i>
        </div>
        <div class="caption hidden-xs hidden-sm">
          <span class="font-weight-bold" v-text="step.title"></span>
        </div>
      </li>
    </ol>
  </div>
</template>

<script>
export default {
  name: 'HMStepper',
  props: {
    id: {
      type: String,
      default: function () {
        return 'stepper-' + this._uid;
      }
    },
    steps: {
      type: Array
    },
    current: {
      type: Number,
      default: 0
    }
  }
};
</script>


<style lang="scss" scoped>
// import variables for this application
@import '@/assets/scss/_variables.scss';

$wizard-color-neutral: #ccc !default;
$wizard-color-active: #4183d7 !default;
$wizard-color-complete: #87d37c !default;
$wizard-step-width-height: 54px !default;
$wizard-step-font-size: 24px !default;

.step-indicator {
  border-collapse: separate;
  display: table;
  margin-left: 0px;
  position: relative;
  table-layout: fixed;
  text-align: center;
  vertical-align: middle;
  padding-left: 0;
  padding-top: 20px;

  li {
    display: table-cell;
    position: relative;
    float: none;
    padding: 0;
    width: 1%;

    &:after {
      background-color: $wizard-color-neutral;
      content: '';
      display: block;
      height: 1px;
      position: absolute;
      width: 100%;
      top: $wizard-step-width-height/2;
    }

    &:after {
      left: 50%;
    }

    &:last-child {
      &:after {
        display: none;
      }
    }

    &.active {
      .step {
        border-color: $wizard-color-active;
        color: $wizard-color-active;
      }

      .caption {
        color: $wizard-color-active;
      }
    }

    &.complete {
      &:after {
        background-color: $wizard-color-complete;
      }

      .step {
        border-color: $wizard-color-complete;
        color: $wizard-color-complete;
      }

      .caption {
        color: $wizard-color-complete;
      }
    }
  }

  .step {
    background-color: #fff;
    border-radius: 50%;
    border: 1px solid $wizard-color-neutral;
    color: $wizard-color-neutral;
    font-size: $wizard-step-font-size;
    height: $wizard-step-width-height;
    line-height: $wizard-step-width-height;
    margin: 0 auto;
    position: relative;
    width: $wizard-step-width-height;
    z-index: 1;
  }

  .caption {
    color: $wizard-color-neutral;
    padding: 11px 16px;
  }
}
</style>